"use client";

import { Suspense } from "react";
import ErrorPage from "@/component/pages/Error";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <Suspense>
      <ErrorPage reset={reset} error={error} />
    </Suspense>
  );
}
